export enum PortalTypes {
  ADMIN = "ADMIN",
  AGGREGO = "AGGREGO"
}
